<div class="checkout_additional-info flex">
  <stxt-svg-icon class="checkout_additional-info__svg" [iconConfig]="infoSvg"></stxt-svg-icon>
  <p class="checkout_additional-info__text">
    All charges will appear on your bank statement as “STXT.AI 866-977-0469”. See JustSext’s
    <a target="_blank" href="{{ ETermsOfService.PaymentPolicy }}">
      Cancellation, Refunds, and Disputes Policy
    </a>
    for additional information.
  </p>
</div>
